import { type FC, memo } from 'react';
import styles from './wallet-unconnect.module.scss';
import { walletConnectModel } from '@models/wallet-connect.model';
import mobileConnectIcon from '@assets/images/header/mobile-connect.svg';
const WalletUnconnect: FC = () => {
  return (
    <>
      <div className={styles.button} key="not-connected" onClick={walletConnectModel.toggleDialog}>
        <img src={mobileConnectIcon} data-icon />
        <span>Connect</span>
      </div>
    </>
  );
};

export default memo(WalletUnconnect);
